// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.widget-numbers[data-v-3e0d4aec] {\n  font-size: 20px;\n}\n.impr-item[data-v-3e0d4aec] {\n  height: 100% !important;\n}\n", ""]);
// Exports
module.exports = exports;
